import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PostHogProvider } from "@posthog/react"

import App from "./app";
import reportWebVitals from "./reportWebVitals";

const options = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  defaults: "2026-05-30",
  opt_out_capturing_by_default: process.env.NODE_ENV !== "production",
} as const;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// React Strict Mode renders the app twice in development to help identify side effects.
// This causes undesirable behavior with some components such as chat.
// https://legacy.reactjs.org/docs/strict-mode.html#detecting-unexpected-side-effects
root.render(
  <React.StrictMode>
    <PostHogProvider apiKey={process.env.REACT_APP_POSTHOG_PROJECT_TOKEN!} options={options}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
